import React, { useEffect, useRef } from "react";
import { Modal } from "react-bootstrap";
import {
  ActionIconContainer,
  AddFormButton,
  CustomLoader,
} from "../../shared/components/TableElements";
import {
  AutoResizeTextArea,
  CheckBoxInput,
  FormContainer,
  FormGroupLabel,
  FormItem,
  Label,
  LinkSpan,
} from "../../shared/components/form/FormElements";
import SelectSuggestedPartsPopup from "../Inventory/components/SelectSuggestedPartsPopup";
import { Col, Container, Row } from "react-bootstrap";
import { Card, CardBody } from "@/shared/components/Card";
import FormField from "../../shared/components/form/FormField";
import Error from "@/shared/components/form/Error";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Controller, useForm } from "react-hook-form";
import { formInputStyles, formStyles } from "../../shared/constants/styles";
import CreatableSelect from "react-select/creatable";
import { Desc } from "../Reminders/MaintenanceReminders/MaintenanceRemindersForm";
import { post } from "../../api/getUser";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {
  fetchServicesTasks,
  fetchServiceTaskCategories,
} from "../../features/servicesTasks/servicesTasksSlice";
import { isObjEmpty } from "../../shared/helpers";
import ErrorPopup from "../../shared/components/ErrorPopup";
import useAutosizeTextArea from "../../shared/custom-hooks/useAutosizeTextArea";
import { useServiceTaskCategory } from "../../shared/custom-hooks/useServiceTaskCategory";
import AddServiceTaskCategoryPopup from "./AddServiceTaskCategoryPopup";
import ServiceTaskCategoryOption from "./ServiceTaskCategoryOption";
import CustomMenuList from "../../shared/components/form/CustomMenuList";
import { NewBadge } from "../../containers/Layout/components/sidebar/SidebarLink";
import { colorLightGray } from "../../utils/palette";
import SubscribePopup from "../../shared/components/SubscribePopup";
import { useAuth } from "../../contexts/AuthContext";

const ServiceTasksFormPopup = ({
  showPopup,
  setShowPopup,
  //newTaskInfo,
  newTaskName,
  vehicleId,
  from,
  onServiceTaskSaved,
  editPartsLaborMode,
  editData,
  onSavePartsAndLaborTime,
  assetIsEquipment = false,
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation("common");
  const {
    handleSubmit,
    reset,
    register,
    control,
    watch,
    getValues,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
  } = useForm({ mode: "onBlur" });

  const { tag } = useAuth();

  const { userId } = useSelector((state) => state.user);

  const [showSubscribePopup, setShowSubscribePopup] = useState(false);
  const [subscribePopupErrMsg, setsubscribePopupErrMsg] = useState("");

  const serviceTaskOptions = useSelector((state) => state.servicesTasks.list);
  const allServiceTaskCategories = useSelector(
    (state) => state.servicesTasks.allServiceTaskCategories,
  );

  const {
    showServiceTaskCategoryPopup,
    setShowServiceTaskCategoryPopup,
    tempServiceTaskCategoryData,
    setTempServiceTaskCategoryData,
    serviceTaskCategoryPopupErr,
    isServiceTaskCategorySaving,
    isServiceTaskCategoryDeleting,
    handleCreateServiceTaskCategory,
    handleSaveServiceTaskCategory,
    handleDeleteServiceTaskCategory,
    handleCloseServiceTaskCategoryPopup,
  } = useServiceTaskCategory();

  const [showErrPopup, setShowErrPopup] = useState(false);

  const [recurringTask, setRecurringTask] = useState(false);
  const [applyToAllVeh, setApplyToAllVeh] = useState(true);

  const isEquipment = assetIsEquipment && !applyToAllVeh;

  const [saveBtnLoading, setSaveBtnLoading] = useState(false);

  const [suggestedParts, setSuggestedParts] = useState([]);
  const [laborHours, setLaborHours] = useState(0);
  const [laborMinutes, setLaborMinutes] = useState(0);
  const [showAddPartsPopup, setShowAddPartsPopup] = useState(false);

  const serviceTaskName = watch("serviceTaskName");
  const comments = watch("comments");
  const serviceTaskCategory = watch("serviceTaskCategory");

  const textAreaRef = useRef(null);
  useAutosizeTextArea(textAreaRef.current, comments);

  //const { taskName, vehicleId } = newTaskInfo?.current || {};

  useEffect(() => {
    if (newTaskName) {
      setValue("serviceTaskName", newTaskName);
    }
  }, [newTaskName]);

  useEffect(() => {
    if (editData && showPopup) {
      const {
        service_task_name,
        suggestedParts,
        estimated_time,
        comments: editComments,
        st_category_id,
        category_name,
        recurring: editRecurring,
        veh_id,
      } = editData;
      console.log("Edit Data in Popup:", editData);

      setValue("serviceTaskName", service_task_name || "");
      setSuggestedParts(suggestedParts || []);
      setValue("comments", editComments || "");

      if (st_category_id) {
        setValue("serviceTaskCategory", {
          value: st_category_id,
          label: category_name || st_category_id,
        });
      } else {
        setValue("serviceTaskCategory", null);
      }

      setRecurringTask(!!editRecurring);

      setApplyToAllVeh(veh_id === "All");

      if (estimated_time) {
        const hours = Math.floor(estimated_time / 3600);
        const minutes = Math.floor((estimated_time % 3600) / 60);
        setLaborHours(hours);
        setLaborMinutes(minutes);
      }
    }
  }, [editData, showPopup]);

  useEffect(() => {
    if (from && from === "recurring-reminder") {
      setRecurringTask(true);
    }
    dispatch(fetchServiceTaskCategories());
  }, []);

  const handleClose = () => {
    reset({
      serviceTaskName: "",
      comments: "",
      serviceTaskCategory: null,
    });
    setRecurringTask(false);
    setApplyToAllVeh(true);
    //if (newTaskInfo) newTaskInfo.current = "";
    if (!isObjEmpty(errors)) {
      clearErrors();
    }
    setShowPopup(false);
  };

  const addServiceTask = async () => {
    // if (editPartsLaborMode) {
    //   onSavePartsAndLaborTime({
    //     parts: suggestedParts,
    //     laborHours,
    //     laborMinutes,
    //   });
    //   setShowPopup(false);
    //   return;
    // }

    if (!serviceTaskName || serviceTaskName?.trim() === "") {
      setError(
        "serviceTaskName",
        {
          type: "required",
          message: t("required_err"),
        },
        { shouldFocus: true },
      );
      return;
    } else {
      clearErrors("serviceTaskName");
    }

    if (!isObjEmpty(errors)) {
      return;
    }
    if (!editPartsLaborMode) {
      for (let serviceTask of serviceTaskOptions) {
        if (applyToAllVeh) {
          if (
            serviceTask.service_task_name.toLocaleLowerCase() ===
            serviceTaskName?.trim().toLocaleLowerCase()
          ) {
            let errMsg = t("dup_service_task_name_error");
            if (
              from &&
              from === "recurring-reminder" &&
              +!serviceTask.recurring
            ) {
              errMsg = t("dup_service_task_name_error_from_reminder");
            }
            setError(
              "serviceTaskName",
              {
                type: "custom",
                message: errMsg,
              },
              { shouldFocus: true },
            );
            return;
          }
        } else {
          if (
            serviceTask.service_task_name.toLocaleLowerCase() ===
              serviceTaskName?.trim().toLocaleLowerCase() &&
            (serviceTask.veh_id === vehicleId || serviceTask.veh_id === "All")
          ) {
            let errMsg = t("dup_service_task_name_error");
            if (
              from &&
              from === "recurring-reminder" &&
              +!serviceTask.recurring
            ) {
              errMsg = t("dup_service_task_name_error_from_reminder");
            }
            setError(
              "serviceTaskName",
              {
                type: "custom",
                message: errMsg,
              },
              { shouldFocus: true },
            );
            return;
          }
        }
      }
    }

    const serviceTaskId =
      editPartsLaborMode && editData
        ? editData?.service_task_id
        : `${userId}_${Date.now()}`;

    const estimatedLaborTime = laborHours * 60 * 60 + laborMinutes * 60;

    const apiData = {
      sync_version: "v2",
      querystring: "add_service_task_v2",
      source: "web",
      service_tasks: [
        {
          service_task_id: serviceTaskId,
          service_task_name: serviceTaskName,
          recurring: recurringTask ? 1 : 0,
          servicetask_veh_id: applyToAllVeh ? "All" : vehicleId,
          comments: comments,
          st_category_id: serviceTaskCategory?.value || "",
          suggested_parts: !isEquipment ? suggestedParts.map((p) => p.part_id) : [],
          estimated_time: !isEquipment ? estimatedLaborTime : 0,
          source: "web",
          sync_version: "v2",
          action: editPartsLaborMode ? 2 : 1,
        },
      ],
    };

    setSaveBtnLoading(true);
    const response = await post("commonNew", apiData);

    if (!response?.success) {
      setSaveBtnLoading(false);
      setShowErrPopup(true);
      return;
    }

    if (response.success === 1) {
      const apiData = {
        querystring: "getallservicetask",
        service_veh_id: "All",
      };
      dispatch(fetchServicesTasks(apiData));
      //setNewServiceTaskId(serviceTaskId);

      if (onServiceTaskSaved) {
        await onServiceTaskSaved(serviceTaskId);
      }

      setSaveBtnLoading(false);
      setShowPopup(false);
    }
  };

  return (
    <>
      {showSubscribePopup && (
        <SubscribePopup
          showPopup={showSubscribePopup}
          setShowPopup={setShowSubscribePopup}
          message={subscribePopupErrMsg}
        />
      )}
      {showErrPopup && (
        <ErrorPopup showPopup={showErrPopup} setShowPopup={setShowErrPopup} />
      )}
      {showServiceTaskCategoryPopup && (
        <AddServiceTaskCategoryPopup
          showPopup={showServiceTaskCategoryPopup}
          setShowPopup={setShowServiceTaskCategoryPopup}
          categoryData={tempServiceTaskCategoryData}
          onSave={(data) =>
            handleSaveServiceTaskCategory({ ...data, setValue, watch })
          }
          onDelete={(categoryId) =>
            handleDeleteServiceTaskCategory(categoryId, setValue, watch)
          }
          onClose={handleCloseServiceTaskCategoryPopup}
          isCreateNew={tempServiceTaskCategoryData?.__isNew__}
          error={serviceTaskCategoryPopupErr}
          isSaving={isServiceTaskCategorySaving}
          isDeleting={isServiceTaskCategoryDeleting}
        />
      )}
      {showAddPartsPopup && (
        <SelectSuggestedPartsPopup
          showPopup={showAddPartsPopup}
          setShowPopup={setShowAddPartsPopup}
          alreadySelectedParts={suggestedParts}
          onPartsSubmitted={(parts) => setSuggestedParts(parts)}
        />
      )}
      <Modal
        show={showPopup && !showAddPartsPopup}
        size="lg"
        backdropClassName="custom-backdrop"
      >
        <Modal.Header>
          <h4>
            {editPartsLaborMode
              ? t("edit_service_task")
              : t("add_service_task")}
          </h4>
          <div
            className="d-flex justify-content-end"
            //style={{ width: "-webkit-fill-available" }}
          >
            <ActionIconContainer onClick={handleClose}>
              <i className="fi fi-rr-cross-small" />
            </ActionIconContainer>
          </div>
        </Modal.Header>
        <Modal.Body className="p-0">
          <FormContainer
            className="p-0 m-0"
            //onSubmit={handleSubmit(onSubmit)}
          >
            {/* <div
            className="d-flex justify-content-end align-items-center"
            style={{ width: "-webkit-fill-available" }}
          >
            <AddFormButton
              id="save-form-button"
              type="button"
              onClick={addServiceTask}
              //disabled={disableSave}
              //isLoading={isSaveLoading}
              //onClick={handleSave}
            >
              {saveBtnLoading ? <CustomLoader /> : t("save")}
            </AddFormButton>
          </div> */}
            {/* <FilterButton
          id="cancel-form-button"
          type="button"
          onClick={handleCancel}
        >
          {t('cancel')}
        </FilterButton> */}
            <Container className="p-0">
              <Card className="p-0">
                <CardBody
                  style={{
                    height: "calc(var(--window-height, 100vh) - 232px)",
                    overflow: "auto",
                  }}
                >
                  <Row>
                    <Col md={6}>
                      <FormGroupLabel className="m-0">
                        {t("service_task_name")}
                      </FormGroupLabel>
                      <FormItem disabled={editPartsLaborMode}>
                        <FormField
                          name="serviceTaskName"
                          control={control}
                          component="input"
                          defaultValue=""
                          placeholder={t("service_task_name")}
                          style={formInputStyles}
                          disabled={editPartsLaborMode}
                          rules={{ required: t("required_err") }}
                        />
                      </FormItem>

                      {errors?.serviceTaskName && (
                        <Error error={errors.serviceTaskName.message} />
                      )}
                    </Col>
                    {/* </Row> */}
                    {/* <Row> */}
                    <Col md={6}>
                      <div
                        className="d-flex align-items-center gap-1"
                        style={{ marginTop: "4px" }}
                      >
                        <FormGroupLabel className="m-0">
                          {t("service_task_category")}
                        </FormGroupLabel>
                        <NewBadge bg="custom">
                          <span style={{ fontSize: "8px", color: "black" }}>
                            {t("new")}
                          </span>
                        </NewBadge>
                      </div>
                      {/* <FormGroupLabel className="d-flex align-items-center gap-1 m-0">
                        {t("service_task_category")}
                        <NewBadge bg="custom">
                          <span style={{ fontSize: "8px", color: "black" }}>
                            {t("new")}
                          </span>
                        </NewBadge>
                      </FormGroupLabel> */}
                      <Controller
                        name="serviceTaskCategory"
                        control={control}
                        render={({ field: { onChange, value } }) => (
                          <CreatableSelect
                            options={allServiceTaskCategories}
                            value={value}
                            onChange={onChange}
                            onCreateOption={handleCreateServiceTaskCategory}
                            placeholder={t("service_task_category_placeholder")}
                            styles={formStyles}
                            isClearable
                            isDisabled={editPartsLaborMode}
                            components={{
                              Option: (optionProps) => (
                                <ServiceTaskCategoryOption
                                  {...optionProps}
                                  setShowServiceTaskCategoryPopup={
                                    setShowServiceTaskCategoryPopup
                                  }
                                  setTempServiceTaskCategoryData={
                                    setTempServiceTaskCategoryData
                                  }
                                />
                              ),
                              MenuList: CustomMenuList,
                            }}
                            onCreateNew={() =>
                              handleCreateServiceTaskCategory("")
                            }
                            createNewLabel={t(
                              "create_new_service_task_category",
                            )}
                            customProps={{ type: "serviceTaskCategory" }}
                            id="service-task-category-dropdown"
                          />
                        )}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col md={12}>
                      <FormGroupLabel>{t("notes_tv")}</FormGroupLabel>
                      <Controller
                        name="comments"
                        control={control}
                        render={({ field: { onChange, value, ref } }) => (
                          <AutoResizeTextArea
                            ref={textAreaRef}
                            onChange={onChange}
                            value={value}
                            placeholder={t("notes_tv")}
                            rows={1}
                            disabled={editPartsLaborMode}
                          />
                        )}
                        isDisabled={editPartsLaborMode}
                      />

                      {errors?.comments && (
                        <Error error={errors.comments.message} />
                      )}
                    </Col>
                  </Row>
                  {/* Suggested Parts + Est. Labor Time box */}
                  {!isEquipment && <div
                    style={{
                      border: `1px solid ${colorLightGray}`,
                      borderRadius: "6px",
                      padding: "12px",
                      marginTop: "8px",
                      backgroundColor: "#f9fafb",
                    }}
                  >
                    <p
                      style={{
                        fontSize: "12px",
                        color: "#888",
                        marginTop: "8px",
                        marginBottom: 0,
                      }}
                    >
                      {t("suggested_parts_defaults_hint")}
                    </p>
                    <Row>
                      <Col md={12}>
                        <FormGroupLabel>{t("suggested_parts")}</FormGroupLabel>
                        {suggestedParts.length === 0 ? (
                          <p
                            style={{
                              fontSize: "13px",
                              color: "#888",
                              margin: "4px 0",
                            }}
                          >
                            {t("no_parts_added_yet")}
                          </p>
                        ) : (
                          <div
                            style={{
                              border: `1px solid ${colorLightGray}`,
                              borderRadius: "5px",
                              overflow: "hidden",
                              marginBottom: "8px",
                            }}
                          >
                            <table
                              style={{
                                width: "100%",
                                borderCollapse: "collapse",
                              }}
                            >
                              <thead>
                                <tr style={{ backgroundColor: "#f9f9f9" }}>
                                  <th
                                    style={{
                                      fontSize: "11px",
                                      fontWeight: 400,
                                      color: "#888",
                                      textTransform: "uppercase",
                                      padding: "6px",
                                      textAlign: "left",
                                    }}
                                  >
                                    {t("part_name")}
                                  </th>
                                  <th
                                    style={{
                                      fontSize: "11px",
                                      fontWeight: 400,
                                      color: "#888",
                                      textTransform: "uppercase",
                                      padding: "6px",
                                      textAlign: "left",
                                    }}
                                  >
                                    {t("part_no")}
                                  </th>
                                  <th style={{ width: "32px" }} />
                                </tr>
                              </thead>
                              <tbody style={{ backgroundColor: "white" }}>
                                {suggestedParts.map((part, idx) => (
                                  <tr
                                    key={part.part_id || idx}
                                    style={{ borderTop: "1px solid #eee" }}
                                  >
                                    <td
                                      style={{
                                        fontSize: "13px",
                                        padding: "6px",
                                      }}
                                    >
                                      {part.part_name}
                                    </td>
                                    <td
                                      style={{
                                        fontSize: "13px",
                                        padding: "6px",
                                      }}
                                    >
                                      {part.part_number || "—"}
                                    </td>
                                    <td>
                                      <span
                                        style={{
                                          cursor: "pointer",
                                          color: "#888",
                                          fontSize: "16px",
                                          lineHeight: 1,
                                        }}
                                        onClick={() =>
                                          setSuggestedParts((prev) =>
                                            prev.filter((_, i) => i !== idx),
                                          )
                                        }
                                      >
                                        &times;
                                      </span>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        )}
                        <LinkSpan
                          onClick={() => {
                            if (tag === "essential-user") {
                              setsubscribePopupErrMsg(
                                t("subscribe_to_advanced_msg"),
                              );
                              setShowSubscribePopup(true);
                              return;
                            }
                            setShowAddPartsPopup(true);
                          }}
                          style={{ fontSize: "13px" }}
                        >
                          + {t("add_suggested_parts")}
                        </LinkSpan>
                      </Col>
                    </Row>
                    <hr className="mt-3 mb-0" />
                    {/* Est. Labor Time */}
                    <Row>
                      <Col md={12}>
                        <FormGroupLabel>{t("est_labor_time")}</FormGroupLabel>
                        <div className="d-flex align-items-center gap-2">
                          <select
                            value={laborHours}
                            onChange={(e) =>
                              setLaborHours(Number(e.target.value))
                            }
                            style={{
                              width: "70px",
                              padding: "4px",
                              borderRadius: "4px",
                              border: "1px solid #ccc",
                            }}
                          >
                            {Array.from({ length: 51 }, (_, i) => (
                              <option key={i} value={i}>
                                {i}
                              </option>
                            ))}
                          </select>
                          <span style={{ fontSize: "13px" }}>
                            {t("hrs_label")}
                          </span>
                          <select
                            value={laborMinutes}
                            onChange={(e) =>
                              setLaborMinutes(Number(e.target.value))
                            }
                            style={{
                              width: "70px",
                              padding: "4px",
                              borderRadius: "4px",
                              border: "1px solid #ccc",
                            }}
                          >
                            {[0, 15, 30, 45].map((m) => (
                              <option key={m} value={m}>
                                {m}
                              </option>
                            ))}
                          </select>
                          <span style={{ fontSize: "13px" }}>
                            {t("min_label")}
                          </span>
                        </div>
                      </Col>
                    </Row>
                  </div>}
                  <Row className="pt-3">
                    <Col md={12}>
                      <CheckBoxInput
                        disabled={
                          from === "recurring-reminder" || editPartsLaborMode
                        }
                        type="checkbox"
                        id="recurringTask"
                        name="recurringTask"
                        value="recurringTask"
                        checked={recurringTask}
                        onChange={() => setRecurringTask((prev) => !prev)}
                        style={{ margin: "0 8px 0 0" }}
                      />
                      <Label
                        htmlFor="recurringTask"
                        disabled={
                          from === "recurring-reminder" || editPartsLaborMode
                        }
                      >
                        {t("recurring_task")}
                      </Label>
                    </Col>
                    <Desc style={{ paddingLeft: "2rem" }}>
                      {t("no_reminder_for_nonrecurring")}
                    </Desc>
                  </Row>
                  <Row className="pt-3">
                    <Col md={12} className="pt-2">
                      <CheckBoxInput
                        disabled={editPartsLaborMode}
                        type="checkbox"
                        id="applyToAllVeh"
                        name="applyToAllVeh"
                        value="applyToAllVeh"
                        checked={applyToAllVeh}
                        onChange={() => setApplyToAllVeh((prev) => !prev)}
                        style={{ margin: "0 8px 0 0" }}
                      />
                      <Label
                        htmlFor="applyToAllVeh"
                        disabled={editPartsLaborMode}
                      >
                        {t("apply_all_vehs")}
                      </Label>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Container>
          </FormContainer>
        </Modal.Body>
        <Modal.Footer>
          <AddFormButton
            id="save-form-button"
            type="button"
            onClick={addServiceTask}
          >
            {saveBtnLoading ? <CustomLoader /> : t("save")}
          </AddFormButton>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ServiceTasksFormPopup;
